
//常量定义
export module Define{
    //调试模式
    export let isDebugMode = false;
    //高亮状态移动高度
    export let moveHeight = 20;

    export let totalTime = 10;//总共执行时间

    export let refreshUI = 'refreshUI';//刷新UI事件

    export let updateUI = 'updateUI';//刷新外部UI事件

    export let green = cc.color(1,2,3,4);
    export let yellow = cc.color(1,2,3,4);

    //提示信息
    export let ActionTip:{[k:number]:string} = {
        1:'',
        2:'operator_call',
        3:'operator_fold',
        4:'operator_check',
        5:'operator_rase',
        6:'',
        7:'operator_all_in',
     } 

     //操作类型对应的气泡类型
    export let bubbleType:{[k:number]:string} = {
        1:'',
        2:'normal', //跟注
        3:'bad',//弃牌
        4:'normal',//让牌
        5:'strong',//加注
        6:'',
        7:'strong',//all-in
        8:'normal',//大盲注
        9:'normal',//小盲注
     } 

    export let pngStr:{[k:number]:string} = {
        2:'operator_small',
        3:'operator_big',
        5:'operator_fold',//弃牌
    }

    export let OpTips:{[k:number]:string} = {
        1:'dz_blind',
        4:'dz_totalpot',
        6:'dz_startnext',
        7:'dz_betleaveroom',
        8:'dz_betfail',
        9:'dz_nextbetto',
        10:'dz_betto'
     } 

     //图片的索引
    export let PokerDes:{[k:number]:string} = {
        1:'pattern_1',//散牌
        2:'pattern_2',//一对
        3:'pattern_3',//两队
        4:'pattern_4',//三条
        5:'pattern_5',//顺子
        6:'pattern_6',//同花
        7:'pattern_7',//葫芦
        8:'pattern_8',//四条
        9:'pattern_9',//同花顺
        10:'pattern_10',//皇家同花顺
     } 

     //系统文字索引
     export let LocalPattern:{[k:number]:string} = {
        1:'dz_pattern_1',
        2:'dz_pattern_2',
        3:'dz_pattern_3',
        4:'dz_pattern_4',
        5:'dz_pattern_5',
        6:'dz_pattern_6',
        7:'dz_pattern_7',
        8:'dz_pattern_8',
        9:'dz_pattern_9',
        10:'dz_pattern_10',
     } 

     //下注状态
     export let CheckState:{[k:number]:string} = {
        8:'operator_big',
        9:'operator_small',
        2:'operator_call',
        5:'operator_rase',
        4:'operator_check',
     }

    //座位相关
    export enum SeatAction{
        //换位置
        Change = 1,
        //站起
        Stand = 2,
        //坐下
        Seat = 3,
        //离开 
        Leave = 4,
        //余额
        Remain = 5,
    }

    //玩家座位状态
    export enum PlayerSeatState{
        None = 0,
        //站起
        Stand = 1,
        //坐下
        Down = 2,
        //观战,弃牌
        Look = 3,
    }

    //玩家状态
    export enum PlayerState{
        //无状态
        None = 0,
        //战斗状态
        Fighting = 1,
        //已经弃牌
        GiveUp = 2,
        //已全押
        All_in = 3,
        //站起观战
        Look_1 = 4,
        //坐下观战
        Look_2 = 5,
    }

    //玩家每轮的操作类型 
    export enum TableSeatAction{
        //无状态
        None = 0,
        //押注
        Bet = 1,
        //跟
        Call = 2,
        //不跟（弃牌）
        Fold = 3,
        //让牌
        Check,
        //加注
        Raise,
        //再加注
        Re_raise,
        //全押
        All_in,
    }

    //下一个动作状态
    export enum NextAction {
        //未开局
        No_opening = 1,
        //确定庄家，大小盲
        Bank_SB=2,
        //下盲注中
        Blinds = 3,
        //给玩家发牌中
        DealCards = 4,
        //玩家动作中
        Player_Actions = 5,
        //发公共牌
        CommonCard = 6,
        //结算
        End = 7,
        //发公共牌+结算
        CommonCard_End = 8,
        //归池
        GuiChi = 9,
        //牌局结束
        GameOver = 10,
        //边池结算
        sidePotEnd = 11,
    }

    //牌局状态
    export enum GameState{
        None = 0,
        //未开局
        No_opening = 1,
        //确定庄家，大小盲
        Bank_SB=2,
        //下盲注中
        Blinds = 3,
        //给玩家发牌中
        DealCards = 4,
        //玩家动作中
        Player_Actions = 5,
        //发公共牌
        CommonCard = 6,
        //结算
        End = 7,
    }

    //操作按钮类型
   export enum Operator{
       GiveUp = 1,//弃牌
       Fold_Check = 2,//跟或者让
       All_in = 3,
       Raise = 4,
   }

   export enum OperatorType{
        Image_Op = 0,//图片操作
        Anim_Op = 1,//动画操作
        Name_Op = 2,//名字操作
    }

    //玩家在牌局座位的状态
    export enum SitState{
        Leave = 1,//离开
        Stand = 2,//站起
        SitDown = 3,//坐下
        enterRoom = 4,//进入房间
    }

    //动画时间配置
    //下注筹码间隔
    export let checkInterval = 0.02
    //下注筹码移动时间
    export let checkMoveTime = 0.2;
    //归池筹码间隔
    export let guiChiInterval = 0.02;
    //归池筹码移动时间
    export let guiChiMoveTime = 0.2;
    //池中获取筹码间隔
    export let obtainInterval = 0.05;
    //池中获取筹码移动
    export let obtainMoveTime = 0.3;
    //手牌展示
    //手牌移动时间
    export let handsMoveTime = 0.25;
    //手牌放大的倍数
    export let handsScalTo = 1.3;
    //结束流程
    //亮牌总时间
    export let lightHandsTime = 0.6;
    //比牌结束时 vector显示时间
    export let vectorShowTime = 1.66;
    //归池完刷新玩家存留时间
    export let rounOverRefresh = 0.3;

}
